<template>
    <div class="flex flex-col justify-between lg:flex-row lg:items-center lg:border-y lg:border-white lg:py-3">
        <div class="h-[100px] overflow-hidden border-t border-white py-2 lg:h-[78px] lg:border-none lg:py-0">
            <iframe
                frameborder="0"
                allowtransparency="true"
                src="https://www.kiyoh.com/retrieve-widget.html?button=true&lang=nl&tenantId=98&locationId=1048036"
                width="175"
                title="kiyoh score"
                height="170"></iframe>
        </div>
        <div class="flex flex-wrap items-center border-y border-white py-4 lg:border-none lg:py-0">
            <IconPaymentIdeal class="size-10 lg:ml-2" :aria-label="$snippets['headless.footer.idealAlt']" />
            <IconPaymentApplePay class="ml-2 size-10" :aria-label="$snippets['headless.footer.applepayAlt']" />
            <IconPaymentMaestro class="ml-2 size-10" :aria-label="$snippets['headless.footer.maestroAlt']" />
            <IconPaymentMastercard class="ml-2 size-10" :aria-label="$snippets['headless.footer.mastercardAlt']" />
            <IconPaymentBancontant class="ml-2 size-10" :aria-label="$snippets['headless.footer.bancontantAlt']" />
            <IconPaymentVisa class="ml-2 size-10" :aria-label="$snippets['headless.footer.visaAlt']" />
            <IconPaymentRivertyTheme class="ml-2 size-10" :aria-label="$snippets['headless.footer.rivertyThemeAlt']" />
        </div>
    </div>
</template>
